import { createAction } from '@reduxjs/toolkit';
export const setQueryClientAction = createAction('SET_QUERY_CLIENT_SAGA');
export const setFeatureFlagAction = createAction('SET_FEATURE_FLAG');
